import React, { Fragment, useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Avatar, CircularProgress, Breadcrumbs } from '@mui/material';
import Layout from '../components/layouts/Layout';
import { useSearch } from "../../src/context/SearchContext";
import CartModel from '../components/common/CartModel';

const ViewCategories = () => {
    const [selectedFood, setSelectedFood] = useState(null);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);  // State for controlling modal visibility

    const {
        vendorTypeCategories,
        get_categories_by_vendor_type,
        products,
        get_products,
    } = useSearch();

    useEffect(() => {
        const fetchData = async () => {
            await get_categories_by_vendor_type();
            await get_products();
            setPageLoaded(true);
        };

        fetchData();
    }, []); // Adding dependencies to avoid re-fetching unnecessarily

    const handleOpenModal = (food) => {
        setSelectedFood(food);
        setModalOpen(true);  // Open modal when a food item is clicked
    };

    const handleCloseModal = () => {
        setModalOpen(false);  // Close modal
    };

    return (
        <Fragment>
            <Layout title={"Food"} logo={"/assets/images/logo.jpeg"}>
            <Breadcrumbs title={"Food"} crumb={"Food"} />
                {!pageLoaded ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                        <CircularProgress />
                    </Box>
                ) : (
                    <Container>
                        <Grid container spacing={3} sx={{ marginTop: 2 }}>
                            {vendorTypeCategories.length > 0 && (
                                <Grid item xs={12} md={3}>
                                    <Typography variant="h5" sx={{ marginBottom: 2 }}>Categories</Typography>
                                    <Grid container spacing={1}>
                                        {vendorTypeCategories.map((category, index) => (
                                            <Grid item xs={6} sm={4} md={12} key={index}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: 1,
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '8px',
                                                    textAlign: 'left',
                                                }}>
                                                    <Avatar src={category.image} alt={category.name} sx={{ width: 25, height: 25, marginRight: 1 }} />
                                                    <Typography variant="body2">{category.name}</Typography>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            )}

                            {/* Campaigns and Popular Foods Section */}
                            <Grid item xs={12} md={9}>
                                {/* Campaigns Section */}
                                <Typography variant="h5" sx={{ marginBottom: 2 }}>Campaigns</Typography>
                                <Typography variant="body1" sx={{ color: 'gray', marginBottom: 4 }}>
                                    Items on discount/campaign
                                </Typography>

                                {/* Popular Foods Section */}
                                <Typography variant="h5" sx={{ marginBottom: 2 }}>Popular Foods Nearby</Typography>
                                <Typography variant="body2" sx={{ color: 'gray', marginBottom: 2 }}>
                                    Best selling products around selected location
                                </Typography>
                                <Grid container spacing={2}>
                                    {products.map((food, index) => (

                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <Box
                                                onClick={() => handleOpenModal(food)} // Open modal when a food is clicked
                                                sx={{
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '8px',
                                                    padding: '16px',
                                                    textAlign: 'center',
                                                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                                    width: '100%',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <img
                                                    src={food.image}
                                                    alt={food.name}
                                                    style={{
                                                        width: '65%',
                                                        height: '100px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        marginBottom: '8px'
                                                    }}
                                                />
                                                <Typography variant="body1" fontWeight="bold">{food.name}</Typography>
                                                <Typography variant="body2" color="text.secondary">{food.brand}</Typography>
                                                <Typography variant="body2" fontWeight="bold">Kshs.{food.price.toFixed(2)}</Typography>

                                                <CartModel
                                                    testOne={() => { }}
                                                    open={modalOpen}
                                                    onClose={handleCloseModal}  // Close modal
                                                    title={food.name}
                                                    item={food}
                                                    is_restro_open={true}
                                                    minimum_order_quantity={1}
                                                    total_allowed_quantity={10}
                                                    product_qty={1}  // 
                                                    type={0}
                                                />
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Container>
                )}


            </Layout>
        </Fragment>
    );
};

export default ViewCategories;
